import React from 'react';
import './Contact.css';

const Contact = () => {
    return (
        <div className="contact-page">
            <div className="container">
                <header className="page-header">
                    <h1>Contact Us</h1>
                    <p>Get in touch with us for stringing services, product inquiries, or any questions</p>
                </header>

                <section className="contact-content">
                    <div className="contact-info">
                        <div className="contact-methods">
                            <a href="tel:+6590688780" className="contact-item">
                                <div className="contact-icon">📞</div>
                                <h3>Phone</h3>
                                <span className="contact-link">+6590688780</span>
                                <p className="contact-note">Call us during business hours</p>
                            </a>

                            <a href="https://wa.me/6588048780" className="contact-item" target="_blank" rel="noopener noreferrer">
                                <div className="contact-icon">💬</div>
                                <h3>WhatsApp</h3>
                                <span className="contact-link">Message Us on WhatsApp</span>
                                <p className="contact-note">Quick responses for urgent inquiries</p>
                            </a>

                            <a href="mailto:takumitension@gmail.com" className="contact-item">
                                <div className="contact-icon">✉️</div>
                                <h3>Email</h3>
                                <span className="contact-link">takumitension@gmail.com</span>
                                <p className="contact-note">For detailed inquiries and quotes</p>
                            </a>

                            <a href="https://maps.google.com/?q=60+Eu+Tong+Sen+St,+Singapore+059804" className="contact-item" target="_blank" rel="noopener noreferrer">
                                <div className="contact-icon">📍</div>
                                <h3>Visit Our Shop</h3>
                                <div className="address">
                                    <p>60 Eu Tong Sen St, #01-17 Furama City Center, Singapore 059804</p>
                                </div>
                                <p className="contact-note">Walk-ins welcome during business hours</p>
                            </a>
                        </div>

                        <div className="business-hours">
                            <h3>Business Hours</h3>
                            <div className="hours-list">
                                <div className="hours-item">
                                    <span className="day">Monday - Friday</span>
                                    <span className="time"><s>9:00 AM - 7:00 PM</s></span>
                                </div>
                                <div className="hours-item">
                                    <span className="day">Saturday</span>
                                    <span className="time"><s>9:00 AM - 5:00 PM</s></span>
                                </div>
                                <div className="hours-item">
                                    <span className="day">Sunday</span>
                                    <span className="time"><s>Closed</s></span>
                                </div>
                            </div>
                            <p className="hours-note">We recommend calling ahead before your visit to confirm availability — we occasionally operate outside regular hours, including late nights.</p>
                        </div>
                    </div>

                    <div className="contact-info">
                        <div className='contact-item'>
                            <h3>Follow Us</h3>
                            <p className="social-description">Stay updated with our latest products, tips, and tennis community!</p>
                            <div className="social-links">
                                <a
                                    href="https://www.instagram.com/takumi_tension"
                                    className="social-link instagram"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Follow us on Instagram"
                                >
                                    <div className="social-icon">
                                        <svg viewBox="0 0 24 24" width="24" height="24">
                                            <path fill="currentColor" d="M12,2.163c3.204,0,3.584,0.012,4.85,0.07c3.252,0.148,4.771,1.691,4.919,4.919c0.058,1.265,0.069,1.645,0.069,4.849c0,3.205-0.012,3.584-0.069,4.849c-0.149,3.225-1.664,4.771-4.919,4.919c-1.266,0.058-1.644,0.07-4.85,0.07c-3.204,0-3.584-0.012-4.849-0.07c-3.26-0.149-4.771-1.699-4.919-4.92c-0.058-1.265-0.07-1.644-0.07-4.849c0-3.204,0.013-3.583,0.07-4.849c0.149-3.227,1.664-4.771,4.919-4.919c1.266-0.057,1.645-0.069,4.849-0.069zm0-2.163c-3.259,0-3.667,0.014-4.947,0.072c-4.358,0.2-6.78,2.618-6.98,6.98c-0.059,1.281-0.073,1.689-0.073,4.948c0,3.259,0.014,3.668,0.072,4.948c0.2,4.358,2.618,6.78,6.98,6.98c1.281,0.058,1.689,0.072,4.948,0.072c3.259,0,3.668-0.014,4.948-0.072c4.354-0.2,6.782-2.618,6.979-6.98c0.059-1.28,0.073-1.689,0.073-4.948c0-3.259-0.014-3.667-0.072-4.947c-0.196-4.354-2.617-6.78-6.979-6.98c-1.281-0.059-1.69-0.073-4.949-0.073zm0,5.838c-3.403,0-6.162,2.759-6.162,6.162c0,3.403,2.759,6.163,6.162,6.163s6.162-2.759,6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0,10.162c-2.209,0-4-1.79-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4c0,2.21-1.791,4-4,4zm6.406-11.845c-0.796,0-1.441,0.645-1.441,1.44s0.645,1.44,1.441,1.44c0.795,0,1.439-0.645,1.439-1.44s-0.644-1.44-1.439-1.44z" />
                                        </svg>
                                    </div>
                                    <span className="social-name">Instagram</span>
                                </a>

                                {/* <a
                                href="https://www.facebook.com/takumitension"
                                className="social-link facebook"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Follow us on Facebook"
                            >
                                <div className="social-icon">
                                    <svg viewBox="0 0 24 24" width="24" height="24">
                                        <path fill="currentColor" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                    </svg>
                                </div>
                                <span className="social-name">Facebook</span>
                            </a> */}

                                <a
                                    href="https://www.tiktok.com/@takumi.tension"
                                    className="social-link tiktok"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Follow us on TikTok"
                                >
                                    <div className="social-icon">
                                        <svg viewBox="0 0 24 24" width="24" height="24">
                                            <path fill="currentColor" d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
                                        </svg>
                                    </div>
                                    <span className="social-name">TikTok</span>
                                </a>
                            </div>
                        </div>
                        <div className="contact-item">
                            <h3>Find Us</h3>
                            <div className="map-container">
                                <div className="map-placeholder">
                                    <div className="map-content">
                                        <h4>Google Maps Integration</h4>
                                        <p>60 Eu Tong Sen St, #01-17 Furama City Center, Singapore 059804</p>
                                        <p className="map-note">
                                            Replace this placeholder with actual Google Maps embed:<br />
                                            <iframe width="100%" height="650px" frameBorder="0" style={{ border: 0 }} src="https://www.google.com/maps/embed/v1/place?key=AIzaSyB2NIWI3Tv9iDPrlnowr_0ZqZWoAQydKJU&q=Eu%20Tong%20Sen%20Street%2C%20Takumi%20Tension%20Pte%20Ltd%2C%20Singapore&maptype=roadmap" allowFullScreen></iframe>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </section>

                <section className="faq-section">
                    <h2>Frequently Asked Questions</h2>
                    <div className="faq-grid">
                        <div className="faq-item">
                            <h4>How long does stringing take?</h4>
                            <p>Standard stringing typically takes 2-3 business days. Express service (24 hours) is available for an additional fee.</p>
                        </div>
                        <div className="faq-item">
                            <h4>What string tension should I use?</h4>
                            <p>String tension depends on your playing style and preferences. We'll provide personalized recommendations based on your needs.</p>
                        </div>
                        <div className="faq-item">
                            <h4>Do you offer same-day service?</h4>
                            <p>Same-day service may be available depending on our current workload. Please call ahead to check availability.</p>
                        </div>
                        <div className="faq-item">
                            <h4>Can I bring my own strings?</h4>
                            <p>Yes, you can bring your own strings. We'll install them for the standard stringing fee.</p>
                        </div>
                    </div>
                </section>

                <section className="service-area">
                    <div className="service-content">
                        <h2>Service Area</h2>
                        <p>We proudly serve tennis and badminton players throughout the Sports District and surrounding areas. Whether you're a recreational player or competing professionally, we're here to help optimize your racquet performance.</p>

                        <div className="contact-cta">
                            <h3>Ready to Book Your Service?</h3>
                            <p>Contact us today to schedule your racquet stringing or ask about our recommendations.</p>
                            <div className="cta-buttons">
                                <a href="tel:+6588048780" className="cta-button primary">
                                    Call Now
                                </a>
                                <a href="https://wa.me/6588048780" className="cta-button secondary" target="_blank" rel="noopener noreferrer" style={{ color: '#000000', border: '2px solid #000000', boxShadow: '0 2px 8px rgba(0,0,0,0.25)' }}>
                                    WhatsApp
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Contact;